// https://vuex.vuejs.org/en/state.html

export default {
  step: 1,
  steps: [],
};
